import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "goods-image" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "small-list" }
const _hoisted_5 = { class: "small" }
const _hoisted_6 = ["onMouseenter"]
const _hoisted_7 = ["src", "alt"]

import { ref, watch } from 'vue';
import { useMouseInElement } from '@vueuse/core';



// 定义 props

export default /*@__PURE__*/_defineComponent({
  __name: 'MagicZoom',
  props: {
    imageList: { default: () => [  // 设置一个默认的图片数据
      { imgUrl: 'https://example.com/default-image.jpg', alt: '默认图片' },
      { imgUrl: 'https://example.com/default-image.jpg', alt: '默认图片' }
    ] }
  },
  setup(__props: any) {

const props = __props;

// 如果 props.imageList 为空或者为 undefined，赋予一个默认值
const imageList = ref(props.imageList && props.imageList.length > 0 ? props.imageList : [
  { imgUrl: 'https://example.com/default-image.jpg', alt: '默认图片' },
  { imgUrl: 'https://example.com/default-image.jpg', alt: '默认图片' }
]);

// 图片列表
const imageListExample: string[] = [
  "https://ts2.cn.mm.bing.net/th?id=OIP-C.k8WVjTHiVmqMmz8396ndDAHaH2&w=242&h=257&c=8&rs=1&qlt=90&o=6&pid=3.1&rm=2",
  "https://ts1.cn.mm.bing.net/th?id=OIP-C.38fQrjUDPHum8kfsXwPsvgHaHa&w=250&h=250&c=8&rs=1&qlt=90&o=6&pid=3.1&rm=2",
  "https://ts2.cn.mm.bing.net/th?id=OIP-C.gj9-M0FI9hXGAV8qGTA7UwHaEU&w=327&h=190&c=8&rs=1&qlt=90&o=6&pid=3.1&rm=2",
  "https://ts3.cn.mm.bing.net/th?id=OIP-C.5uMzGH7lZNGNa3IxHWE4zgHaHa&w=250&h=250&c=8&rs=1&qlt=90&o=6&pid=3.1&rm=2",
  "https://ts3.cn.mm.bing.net/th?id=OIP-C.XOiKAi-VgrUddVegTi9IuAHaEo&w=316&h=197&c=8&rs=1&qlt=90&o=6&pid=3.1&rm=2"
];

// 当前选中的大图索引
const activeIndex = ref<number>(0);

// 切换大图显示
const enterHandler = (i: number): void => {
  activeIndex.value = i;
};

// 获取鼠标相对位置
const target = ref<HTMLElement | null>(null);
const { elementX, elementY, isOutside } = useMouseInElement(target);

// 控制滑块跟随鼠标
const left = ref<number>(0);
const top = ref<number>(0);

const positionX = ref<number>(0);
const positionY = ref<number>(0);

// 监听鼠标位置变化
watch([elementX, elementY, isOutside], () => {
  // 如果鼠标没有移入到盒子里面，直接不执行后面的逻辑
  if (isOutside.value) return;

  // 横向控制滑块的位置
  if (elementX.value > 100 && elementX.value < 300) {
    left.value = elementX.value - 100;
  }
  if (elementX.value > 300) left.value = 200;
  if (elementX.value < 100) left.value = 0;

  // 纵向控制滑块的位置
  if (elementY.value > 100 && elementY.value < 300) {
    top.value = elementY.value - 100;
  }
  if (elementY.value > 300) top.value = 200;
  if (elementY.value < 100) top.value = 0;

  // 控制大图的显示
  positionX.value = -left.value * 2;
  positionY.value = -top.value * 2;
  
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "middle",
        ref_key: "target",
        ref: target
      }, [
        (imageList.value && imageList.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (imageList.value[activeIndex.value])
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: imageList.value[activeIndex.value].imgUrl,
                    alt: imageList.value[activeIndex.value].alt
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", {
                class: "layer",
                style: _normalizeStyle({ left: `${left.value}px`, top: `${top.value}px` })
              }, null, 4), [
                [_vShow, !_unref(isOutside)]
              ])
            ]))
          : _createCommentVNode("", true)
      ], 512),
      _withDirectives(_createElementVNode("div", {
        class: "large",
        style: _normalizeStyle([{
      backgroundImage: `url(${imageList.value[activeIndex.value].imgUrl})`,
      backgroundPositionX: `${positionX.value}px`,
      backgroundPositionY: `${positionY.value}px`,
    }])
      }, null, 4), [
        [_vShow, !_unref(isOutside)]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageList.value, (img, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i,
            onMouseenter: ($event: any) => (enterHandler(i)),
            class: _normalizeClass({ active: i === activeIndex.value })
          }, [
            (imageList.value[activeIndex.value].imgUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: img.imgUrl,
                  alt: img.alt
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ], 42, _hoisted_6))
        }), 128))
      ])
    ])
  ], 64))
}
}

})